import { useContext, useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import queryDefs from '../lib/queryDefs';
import Alert from './Alert';
import { UserContext } from './App';

export default function AppStatus() {
  const { id, dismissedMessages } = useContext(UserContext);
  const [showEndTimeSurvey, setShowEndTimeSurvey] = useState(false);

  const [dismissMessage] = useMutation(queryDefs.dismissMessage, {
    refetchQueries: ['UserContext'],
  });

  useEffect(() => {
    if (!id) return;

    // If it's past Dec 8, 2025 PST don't show the survey
    const cutoffDate = new Date('2025-12-08T08:00:00Z');

    if (new Date() > cutoffDate) return;

    import('../lib/surveyUsers').then(({ default: surveyUsers }) => {
      if (
        surveyUsers.includes(id) &&
        !dismissedMessages.includes('auction-end-time-survey')
      ) {
        setShowEndTimeSurvey(true);
      }
    });
  }, [id, dismissedMessages, dismissMessage]);

  return (
    <div className="tw-px-4">
      <div className="tw-mx-auto tw-max-w-screen-2xl">
        {showEndTimeSurvey && (
          <Alert
            className="tw-my-4"
            onClose={() => {
              dismissMessage({
                variables: { messageId: 'auction-end-time-survey' },
                refetchQueries: ['UserContext'],
              });
            }}
            title="Have your say on Auction end times"
            severity="info">
            We’re reviewing our end time schedules and want to know what works
            for you. Share your ideal bidding window and shape the future of
            Auctions, all from one short survey.{' '}
            <a
              href="https://namecheap.typeform.com/auctionendtime#email=xxxxx"
              target="_blank"
              rel="noopener noreferrer">
              Tell us now →
            </a>
          </Alert>
        )}
      </div>
    </div>
  );
}
